import React from "react";
import styled from "styled-components";
import { colors2 } from "oolib";
import { UI_CAPTION_DF } from "oolib/dist/v2/components/Typo2";

/**
 * The personas a speaker carries, as pills: the role lens first (their
 * relationship to the product — Client, Prospect, Partner…), then the
 * usage lens (how much they use it — New User, Power User…). Reads
 * `personas.{role,usage}` ({ display } or null) and `isProductSide` off
 * the row; set `valuePath` to an always-present field (`id`).
 *
 * Two outline pills say why there is nothing filled in: "Your team" for a
 * voice that is entirely the product's side (the interviewer, the
 * demo-er — left out of the analysis), "Unassigned" for a customer the
 * annotator could not place in either lens.
 */
const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.9rem;
  border-radius: 999px;
  background: ${(p) => (p.$outline ? "transparent" : colors2.grey5)};
  border: 1px solid ${(p) => (p.$outline ? colors2.grey20 : "transparent")};
  color: ${colors2.grey80};
  white-space: nowrap;
  max-width: 100%;
  min-width: 0;
`;
const Pills = styled.div`
  display: flex;
  gap: 0.6rem;
  min-width: 0;
  overflow: hidden;
`;
const Ellipsis = { overflow: "hidden", textOverflow: "ellipsis", color: "inherit" };

const TablePersonas = ({ tableRowData }) => {
  const role = tableRowData?.personas?.role?.display;
  const usage = tableRowData?.personas?.usage?.display;
  const pills = [role, usage].filter(Boolean);
  if (tableRowData?.isProductSide) pills.length = 0;
  const empty = tableRowData?.isProductSide ? "Your team" : "Unassigned";
  return (
    <Pills title={pills.join(" · ") || empty}>
      {pills.length ? (
        pills.map((p) => (
          <Pill key={p}>
            <UI_CAPTION_DF style={Ellipsis}>{p}</UI_CAPTION_DF>
          </Pill>
        ))
      ) : (
        <Pill $outline>
          <UI_CAPTION_DF style={Ellipsis}>{empty}</UI_CAPTION_DF>
        </Pill>
      )}
    </Pills>
  );
};

export default TablePersonas;
